import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-white via-sky-50 to-white">

      {/* ── Kasumisou bouquet blended into background ── */}
      {/* Right side - large bouquet fading into background */}
      <div
        className="absolute pointer-events-none"
        style={{
          top: 0,
          right: 0,
          width: '55%',
          height: '100%',
          maskImage: 'linear-gradient(to left, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.6) 30%, rgba(255,255,255,0.15) 65%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to left, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.6) 30%, rgba(255,255,255,0.15) 65%, transparent 100%)',
        }}
      >
        <img
          src="https://readdy.ai/api/search-image?query=gypsophila%20baby%20breath%20white%20flowers%20bouquet%20horizontal%20arrangement%20lying%20flat%20elegant%20soft%20pastel%20white%20background%20airy%20delicate%20minimal%20botanical%20photography&width=900&height=700&seq=kasumi_main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
          style={{ mixBlendMode: 'multiply' }}
        />
      </div>

      {/* Top right corner - soft fade */}
      <div
        className="absolute pointer-events-none"
        style={{
          top: 0,
          right: 0,
          width: '45%',
          height: '50%',
          maskImage: 'radial-gradient(ellipse at top right, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.3) 50%, transparent 80%)',
          WebkitMaskImage: 'radial-gradient(ellipse at top right, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.3) 50%, transparent 80%)',
        }}
      >
        <img
          src="https://readdy.ai/api/search-image?query=gypsophila%20baby%20breath%20white%20flowers%20soft%20cloud%20airy%20delicate%20white%20background%20minimal%20botanical%20close%20up%20macro%20photography&width=700&height=500&seq=kasumi_top&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          style={{ mixBlendMode: 'multiply' }}
        />
      </div>

      {/* Bottom right - trailing flowers */}
      <div
        className="absolute pointer-events-none"
        style={{
          bottom: 0,
          right: 0,
          width: '40%',
          height: '45%',
          maskImage: 'radial-gradient(ellipse at bottom right, rgba(255,255,255,0.65) 0%, rgba(255,255,255,0.25) 50%, transparent 80%)',
          WebkitMaskImage: 'radial-gradient(ellipse at bottom right, rgba(255,255,255,0.65) 0%, rgba(255,255,255,0.25) 50%, transparent 80%)',
        }}
      >
        <img
          src="https://readdy.ai/api/search-image?query=gypsophila%20baby%20breath%20white%20flowers%20scattered%20petals%20elegant%20soft%20white%20background%20airy%20delicate%20minimal%20botanical%20photography&width=600&height=450&seq=kasumi_bot&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-bottom"
          style={{ mixBlendMode: 'multiply' }}
        />
      </div>

      {/* Subtle sky-blue tint overlay to unify with background */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at 80% 50%, rgba(186,230,253,0.18) 0%, transparent 70%)',
        }}
      />

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 pt-24 pb-16">
        <div className="max-w-xl">
          <span className="inline-block text-sky-400 text-sm font-medium tracking-widest uppercase mb-6">
            Beauty × Marketing
          </span>
          <h1 className="text-4xl md:text-6xl font-light text-slate-800 leading-tight mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            美しさを、<br />
            <span className="font-semibold text-sky-400">ビジネスに。</span>
          </h1>
          <p className="text-slate-500 text-base md:text-lg leading-relaxed mb-10 max-w-md">
            美容の専門知識とマーケティングの力で、<br className="hidden md:block" />
            あなたのビジネスを丁寧にサポートします。
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/services"
              className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-sky-300 text-white text-sm font-medium hover:bg-sky-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              サービスを見る
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-8 py-3 rounded-full border border-sky-300 text-sky-400 text-sm font-medium hover:bg-sky-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              無料相談はこちら
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 30 C360 60, 1080 0, 1440 30 L1440 60 L0 60 Z" fill="white" />
        </svg>
      </div>
    </section>
  );
}
